// extracted by mini-css-extract-plugin
export default {"imageCaptionContainer":"ImageShadowCaption-module__imageCaptionContainer___2oOOB","imageCaptionText":"ImageShadowCaption-module__imageCaptionText___1TFOL"};